export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf04-de.fcdf8a6a.png";